import { useTranslations } from 'next-intl'

import { RoomSortOption } from '@/entities/room'

export const useSortOptionLabelMap = () => {
  const t = useTranslations('search_result.result.sort')

  const SORT_OPTION_LABEL_MAP: Record<RoomSortOption, string> = {
    [RoomSortOption.POPULAR]: t('popular'),
    [RoomSortOption.LOW_PRICE]: t('low_price'),
    [RoomSortOption.HIGH_PRICE]: t('high_price'),
    [RoomSortOption.RECENT]: t('newest'),
  }

  return { SORT_OPTION_LABEL_MAP }
}
